import React, { memo, useContext } from 'react';

import { AppContext } from 'src/components/app-context';

import type { Stars, SecondaryColors, Rating } from './types';

type Props = {
  className?: string;
  size?: number;
  stars: Stars;
  secondaryColors?: SecondaryColors;
  expertColors?: boolean;
  rating: Rating;
  halfStar: boolean;
};

const StarIcons = ({
  size = 16,
  stars,
  rating,
  secondaryColors,
  expertColors,
  halfStar,
  className,
}: Props) => {
  const { market } = useContext(AppContext);

  return (
    <div
      style={{
        width: (size + 1) * stars.length,
        lineHeight: 0,
      }}
      className={className}
    >
      {stars.map(star => {
        const cdn = market && market.cdn ? market.cdn : 'https://cdn.pji.nu';
        let file = 'empty-new';
        let alt = 'Empty Star';

        if (halfStar && rating.whole === star) {
          // Half stars
          if (secondaryColors) {
            file = 'alt-half';
            alt = 'Half Star';
          } else if (expertColors) {
            file = 'expert-half-new';
            alt = 'Half Star';
          } else {
            file = 'primary-half-new';
            alt = 'Half Star';
          }
        } else if (rating.whole >= star) {
          if (secondaryColors) {
            file = 'alt-full';
            alt = 'Full Star';
          } else if (expertColors) {
            file = 'expert-full-new';
            alt = 'Full Star';
          } else {
            file = 'primary-full-new';
            alt = 'Full Star';
          }
        }

        return (
          <img
            key={`star-${star}`}
            style={{
              width: size,
              height: size,
              marginRight: '1px',
            }}
            src={`${cdn}/g/rfe/icons/stars/${file}.svg`}
            alt={`${alt} ${star}`}
          />
        );
      })}
    </div>
  );
};

export default memo(StarIcons);
